import { useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import { GlobalContext } from '../GlobalContext/GlobalContext';
import ActivityTypes from '@/constants/ActivityTypes';
import useCustomHook from '@/hooks/useCustomHook';

export default function usePublicPage() {
  const router = useRouter();
  const globalContext = useContext(GlobalContext);
  const { state, actions } = useCustomHook({
    defaultState: {
      menuVisible: false,
    },
    actions: {
      toggleMenu: () => {
        actions.setState({ menuVisible: !state.menuVisible });
      },
    },
  });

  useEffect(() => {
    if (
      router.isReady &&
      globalContext.state.loaded &&
      globalContext.state?.user
    ) {
      const activityTypeSlugs = Object.values(ActivityTypes.toSlug);

      const [, urlActivityType] = router.asPath.split('/');
      const activityType =
        router.query.activityType ||
        activityTypeSlugs.find(
          (activityTypeSlug) => urlActivityType == activityTypeSlug
        );

      const { activitySlug } = router.query;

      if (globalContext.state.user?.student) {
        redirectStudent(router, activityType, activitySlug);
        return;
      }
    }
  }, [globalContext.state, router.isReady]);

  return { state, actions };
}

function redirectStudent(router, activityType, activitySlug) {
  let url = '/student/dashboard';

  if (activityType) {
    url = `/student/activitiesBySlug/${activityType}`;
    if (activitySlug) {
      url += `/${router.query.activitySlug}`;
    }
  }
  router.replace(url);
}
